import React from 'react';

const DetailedTable = ({ data }) => {
  const headers = data?.headers || [];
  const rows = data?.rows || [];
  const periodLabel = data?.periodLabel || 'Próximas 24 horas';

  if (!headers.length || !rows.length) {
    return (
      <div className="summary-empty">
        <div className="summary-empty-icon">🕒</div>
        <div className="summary-empty-text">No hay datos horarios</div>
        <div className="summary-empty-subtext">Genera un pronóstico para ver la distribución horaria.</div>
      </div>
    );
  }

  return (
    <>
      <div className="detailed-header">
        <h2>Vista Detallada por Horas</h2>
        <div className="detailed-info">
          <span id="detailed-period">{periodLabel}</span>
        </div>
      </div>
      <div className="detailed-table-container">
        <table className="detailed-table react-table">
          <thead>
            <tr>
              {headers.map((header) => (
                <th key={header}>{header}</th>
              ))}
            </tr>
          </thead>
          <tbody>
            {rows.map((row) => (
              <tr key={row.label}>
                <td>{row.label}</td>
                {row.values.map((value, index) => (
                  <td key={`${row.label}-${index}`} style={{ textAlign: 'center' }}>
                    {value}
                  </td>
                ))}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </>
  );
};

export default DetailedTable;

